<template>
  <VMenu
    open-on-hover
    offset-y
    bottom
  >
    <template #activator="{ on, attrs }">
      <VBtn
        text
        class="pl-1 pr-0"
        v-bind="attrs"
        v-on="on"
      >
        <VIcon>mdi-translate</VIcon>
        <span class="d-none d-md-block ml-2">{{ availableLocales[selectedLocaleIndex].text }}</span>
        <VIcon>mdi-menu-down</VIcon>
      </VBtn>
    </template>
    <VList>
      <VListItemGroup
        v-model="selectedLocaleIndex"
        color="primary"
      >
        <VListItem
          v-for="(locale, i) in availableLocales"
          :key="locale.value"
          @click="selectedLocaleIndex = i"
        >
          <VListItemTitle>{{ locale.text }}</VListItemTitle>
        </VListItem>
      </VListItemGroup>
    </VList>
  </VMenu>
</template>

<script>
export default {
  computed: {
    selectedLocaleIndex: {
      get: function () {
        return this.availableLocales.findIndex((locale) => locale.value === this.currentLocale)
      },
      set: function (index) {
        // this.storeApiDispatch('Auth/setUserLocale', { id: this.availableLocales[index].id })
        this.changeLocale(this.availableLocales[index].value)
      }
    }
  }
}
</script>

<style>

</style>
